import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { captureAffiliateReferral } from "../utils/affiliate";

export default function AffiliateRedirectPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let canceled = false;
    const run = async () => {
      await captureAffiliateReferral({
        code,
        landingPath: `/ref/${encodeURIComponent(code || "")}`,
        referrer: document.referrer || "",
      });
      if (!canceled) {
        navigate("/login?mode=signup", { replace: true });
      }
    };
    run();
    return () => {
      canceled = true;
    };
  }, [code, navigate]);

  return (
    <div className="page">
      <p>Opening ClearBadge...</p>
    </div>
  );
}
